import React from "react";
import SectionHeader from "./SectionHeader";
import Input from "../util/Input";
import Select from "../util/Select";
import { PropTypes } from "prop-types";
import HelpBlock from "./HelpBlock";

// "Company Address" section of the Figma form
const CompanyInfo = props => {
  const ceSelected = props.claimingEntitlementAs !== 0;
  const fe = props.fieldErrors || {};

  return (
    <div className='AppSection regSection'>
      <SectionHeader title={"Company Address"} showHr={false} />
      {ceSelected && (
        <HelpBlock claimingEntitlementAs={props.claimingEntitlementAs} />
      )}

      <Input
        labelText={"Company Name"}
        placeholder='Enter company name'
        isRequired={true}
        value={props.orgData.CompanyName}
        readOnly={props.isOrgLock}
        onChange={props.handleCompanyNameChange}
        errorText={fe.companyName}
        maximumLength={160}
      />
      <Select
        labelText={"Country/Region"}
        optionValues={props.countries}
        isRequired={true}
        value={props.orgData.CompanyCountry}
        onChange={props.handleCompanyCountryChange}
        errorText={fe.companyCountry}
        displayFieldName='countryName'
        valueFieldName='id'
      />
      <div className='regRow regRow--2'>
        <Input
          labelText={"Address Line 1"}
          placeholder='Enter address line 1'
          isRequired={true}
          value={props.orgData.CompanyStreet1}
          onChange={props.handleStreet1Change}
          errorText={fe.companyStreet1}
          maximumLength={40}
        />
        <Input
          labelText={"Address Line 2"}
          placeholder='Enter address line 2'
          value={props.orgData.CompanyStreet2}
          onChange={props.handleStreet2Change}
          maximumLength={40}
        />
      </div>
      <div className='regRow regRow--3'>
        <Input
          labelText={"City"}
          placeholder='Enter city'
          isRequired={true}
          value={props.orgData.CompanyCity}
          onChange={props.handleCityChange}
          errorText={fe.companyCity}
          maximumLength={40}
        />
        <Select
          labelText={"State/Province"}
          optionValues={props.states}
          isRequired={true}
          value={props.orgData.CompanyState}
          onChange={props.handleCompanyStateChange}
          errorText={fe.companyState}
          displayFieldName='stateName'
          valueFieldName='id'
          readOnly={props.states[0].id === -1}
        />
        <Input
          labelText={"Zip/Postal Code"}
          placeholder='Enter zip/postal code'
          isRequired={true}
          value={props.orgData.CompanyZip}
          onChange={props.handleZipChange}
          errorText={fe.companyZip}
          maximumLength={10}
        />
      </div>
      <Select
        labelText={"Company Industry"}
        optionValues={props.industryOptions}
        isRequired={true}
        value={props.orgData.CompanyIndustry}
        onChange={props.handleCompanyIndustryChange}
        errorText={fe.companyIndustry}
      />
    </div>
  );
};

CompanyInfo.propTypes = {
  orgData: PropTypes.object,
  isOrgLock: PropTypes.bool.isRequired,
  pecProvided: PropTypes.bool,
  handleCompanyNameChange: PropTypes.func.isRequired,
  handleCompanyCountryChange: PropTypes.func.isRequired,
  handleCompanyStateChange: PropTypes.func.isRequired,
  handleCompanyIndustryChange: PropTypes.func.isRequired,
  claimingEntitlementAs: PropTypes.number,
  handleStreet1Change: PropTypes.func.isRequired,
  handleStreet2Change: PropTypes.func.isRequired,
  handleCityChange: PropTypes.func.isRequired,
  handleZipChange: PropTypes.func.isRequired,
  countries: PropTypes.array.isRequired,
  states: PropTypes.array.isRequired,
  industryOptions: PropTypes.array.isRequired,
  fieldErrors: PropTypes.object
};

export default CompanyInfo;
